/** Emails that have created a DemandJet account in this browser. */

const STORAGE_KEY = 'demandjet.joinedAccounts';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(all) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function normalizeJoinedEmail(email) {
  return String(email || '')
    .trim()
    .toLowerCase();
}

export function listJoinedAccounts() {
  const all = readAll();
  const out = {};
  for (const [email, row] of Object.entries(all)) {
    const key = normalizeJoinedEmail(email);
    if (!key || !row || typeof row !== 'object') continue;
    out[key] = {
      email: key,
      displayName: String(row.displayName || '').trim(),
      avatarDataUrl: String(row.avatarDataUrl || '').trim(),
      joinedAt: row.joinedAt || '',
    };
  }
  return out;
}

export function lookupJoinedAccount(email) {
  const key = normalizeJoinedEmail(email);
  if (!key) return null;
  return listJoinedAccounts()[key] || null;
}

/** Remember a signup or profile save so the inviter's people list can see it. */
export function markJoinedAccount(email, patch = {}) {
  const key = normalizeJoinedEmail(email);
  if (!key) return null;
  const all = readAll();
  const prior = all[key] && typeof all[key] === 'object' ? all[key] : {};
  const next = {
    email: key,
    displayName:
      patch.displayName !== undefined
        ? String(patch.displayName || '').trim()
        : String(prior.displayName || '').trim(),
    avatarDataUrl:
      patch.avatarDataUrl !== undefined
        ? String(patch.avatarDataUrl || '').trim()
        : String(prior.avatarDataUrl || '').trim(),
    joinedAt: prior.joinedAt || new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
  all[key] = next;
  writeAll(all);
  return next;
}
